import { render } from "./BookForm.vue?vue&type=template&id=4fccece3"
import script from "./BookForm.vue?vue&type=script&lang=js"
export * from "./BookForm.vue?vue&type=script&lang=js"
script.render = render

export default script